import Aux from "../../hoc/Auxiliary";
import Tab from "./Tab";
import Pane from "./Pane"
import "./Tabs.css"
import React from "react";
import ReactDOM from "react-dom";

class Tabs extends React.Component {
    constructor(props) {
      super(props);
       this.state = { current : 0 };
    }
    // toggleCurrent(event){
    //     console.log(event.target.Parent());
    //     this.setState({ current : event.target.index });
    //   }
    render() {
        if(this.props.layout == 'first'){
            let tabs = this.props.items.map((item,index) => (
                // <Tab data={item} id={index} isActive={this.state.current === index} click={this.toggleCurrent}/>
                <Tab data={item} id={this.props.WpId + "_" + index} isActive={this.state.current === index} mobile={this.props.mobile}/>
            ));
            let panes = this.props.items.map((item,index) => (
                <Pane data={item} id={this.props.WpId + "_" + index} isActive={this.state.current === index}/>
            ));
            return ( 
                <Aux className={this.props.type +"_"+ this.props.layout}>
                    <div className={"tabZone " +(this.props.mobile ? "row" : "container")}>
                        <ul className={"nav nav-tabs " + (this.props.mobile ? "flex-column col-4" : "row ")} 
                                id={"navTabs_"+ this.props.WpId} 
                                role="tablist" 
                                aria-orientation={this.props.mobile ? "vertical" : ""}>
                            { tabs}
                        </ul>
                        <div className={"tab-content "+ (this.props.mobile ? "col-8" : "row ")} id={"tabContent_" + this.props.WpId}>
                            { panes }
                        </div>
                        <div className="readMoreWrap">
                            <div className="readMoreDiv">
                                <a href={this.props.moreLink} className="readMoreLink">{this.props.moreTitle} ></a>
                            </div>
                        </div>
                    </div>
                </Aux>
            );
        }
    }
}

export default Tabs;